var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly,"items":_vm.listData,"rules":_vm.rules,"label":_vm.label,"required":_vm.required,"item-text":_vm.text,"item-value":"jenisSetoran"},on:{"change":_vm.onSelect},model:{value:(_vm.data),callback:function ($$v) {_vm.data=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }